import React from 'react';
import {
  DEFAULT_PDF_ZOOM,
  DRAW_MACHINE,
  RAFFLE,
  RAFFLE_PAGES,
} from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import './Raffle.css';
import { userInfoSelector } from '../../redux/selectors/auth';
import { listMachine } from '../../redux/actions/settings';
import {
  loadingSelector,
  machineSelector,
} from '../../redux/selectors/settings';
import ManageRaffleStepper from './ManageRaffleStepper';
import {
  raffleCustomersSelector,
  rafflesSelector,
} from '../../redux/selectors/customer';
import {
  clearAllCustomers,
  deleteRaffle,
  listAllRaffles,
  listRaffleCustomers,
  saveRaffle,
  uploadRafflePhoto,
} from '../../redux/actions/customer';
import RaffleTable from './RaffleTable';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../redux/actions/ticketOut';
import { globalPDFPreviewReadySelector } from '../../redux/selectors/ticketOut';
import Utils from '../Utils/Utils';
import DrawIcon from '@mui/icons-material/Draw';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../reading/masterReading/constants';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import RenderPurchaseOrderPDFPreview from '../transaction/RenderPurchaseOrderPDFPreview';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomToolbar from '../global/CustomToolbar';

class Raffle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: RAFFLE_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      feedbackStatus: '',
      feedbackMessage: '',
      isHideToolbar: false,
      //report
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar(this.props.status.statusText, 'error');
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  componentDidMount() {
    this.props.listMachine(this.props.user.selectedLocationId);
    this.props.listAllRaffles({ userId: this.props.user.userId });
  }

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  fetchPdf = async () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    this.props.getGlobalPDFPreview(
      { userId: this.props.user.userId, date: getTodayDate },
      this.showPdfErrorMessage,
      'previewRaffleReport'
    );
    this.setState({ showPdfViewer: true });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.user.firstname} Raffle Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displayTable = () => {
    return (
      <RaffleTable
        handleDeleteRow={this.handleDeleteRow}
        raffles={this.props.raffles}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
      />
    );
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case RAFFLE_PAGES.DISPLAY:
        return this.displayStepper();
      case RAFFLE_PAGES.TABLE:
        return this.displayTable();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  displayStepper = () => {
    return (
      <ManageRaffleStepper
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        machines={this.props.machines}
        raffleCustomers={this.props.raffleCustomers}
        fetchSearch={this.fetchSearch}
        loadingData={this.props.loadingData}
        saveRaffle={this.props.saveRaffle}
        uploadRafflePhoto={this.props.uploadRafflePhoto}
        user={this.props.user}
        clearAllCustomers={this.props.clearAllCustomers}
        setDisableToolBar={this.setDisableToolBar}
      />
    );
  };

  handleDeleteRow = (deleteId) => {
    this.props.deleteRaffle({ raffleId: deleteId });
  };

  fetchSearch = (name) => {
    this.props.listRaffleCustomers({
      search: name,
      locationId: this.props.user.selectedLocationId,
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  setDisableToolBar = (bool) => {
    this.setState({ isHideToolbar: bool });
  };

  render() {
    const { showPdfViewer, pdfData, scale } = this.state;
    let headerButtons;
    headerButtons = [];
    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else {
      headerButtons.push(
        {
          title: DRAW_MACHINE,
          icon: <DrawIcon />,
          handler: () => {
            this.setDisableToolBar(true);
            this.setCurrentPage(RAFFLE_PAGES.DISPLAY, {});
          },
        },
        {
          icon: <VisibilityIcon />,
          title: 'View Report',
          handler: () => this.fetchPdf(),
        }
      );
    }

    return (
      <React.Fragment>
        {!this.state.isHideToolbar && (
          <CustomToolbar
            title={RAFFLE}
            createTitle={''}
            backTitle={''}
            headerButtons={headerButtons}
          />
        )}

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : this.state.currentPage === RAFFLE_PAGES.DISPLAY ? (
          <div className="raffle-stepper-shell">{this.displayCurrentPage()}</div>
        ) : (
          <div className="raffle-page-root">{this.displayCurrentPage()}</div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  machines: machineSelector(state),
  raffleCustomers: raffleCustomersSelector(state),
  raffles: rafflesSelector(state),
  loadingData: loadingSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
});

const actionCreators = {
  clearStatus,
  listMachine,
  listRaffleCustomers,
  listAllRaffles,
  deleteRaffle,
  saveRaffle,
  uploadRafflePhoto,
  clearAllCustomers,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  Raffle
);
